export const CoursesGroups = [
  ['Foundations', 'MasteringPersonalEffectiveness'],
  ['Fundamentals', 'RemoteWorkProfessional'],
  ['FundamentalsManager', 'RemoteWorkProfessionalManager'],
];
export const emailRegex = /^[\w\.]+@([\w-]+\.)+[\w-]{2,4}$/m;
export const domainRegex = /^([\w-]+\.)+[\w-]{2,4}$/m;
